<template>
  <div id="app" v-if="!$route.path.includes('login')">
    <mds-page-shell>
    <template #mds-page-shell-masthead-left>
      <mds-page-shell 
      :logo="logoUrl"
      :logo-responsive="logoUrl"
      logo-alt="Morningstar"
      logo-href="#"
    >  </mds-page-shell>
    <p style="color:#005ba1;font-size: larger;font-weight: bold;"> Conference Call Tracker</p>
    <!-- <mds-empty-state title="Corporate Communication" ></mds-empty-state> -->
    </template> 
    <template #mds-page-shell-masthead-right>
      <!-- <mds-empty-state message="Welcome , User (Admin)" style="color:blue"></mds-empty-state> -->
       <p v-if="isAuth" style="color: red;font-size: medium;font-weight: bold;"> Welcome , {{ userDetails.data.name }}  ( {{ userDetails.data.emailId }} ) </p>   
        <mds-button
          variation="flat"
          icon="person"
          flat-button-icon-size="medium"
          v-on:click="SignOut"
          >Sign Out</mds-button
        >
      </template>

      <template #mds-page-shell-horizontal-nav>
        <mds-tabs variation="site-navigation" size="large" style="margin-top:1%;margin-right:1%;margin-left:1%;">
          <mds-tabs-item v-if="isAuth" :active="isconferenceDetails" to="/conferenceDetails">Conference Call Tracker</mds-tabs-item>
          <!-- <mds-tabs-item v-if="isAuth" :active="isuserList" to="/userList">User List</mds-tabs-item> -->
          <mds-tabs-item v-if="isAuth" :active="iskeywordManagement" to="/keywordManagement">Manage Keywords</mds-tabs-item>

        </mds-tabs>
      </template>
    </mds-page-shell>
  </div>
  <router-view></router-view>
</template>

<script>
import MdsPageShell from "@mds/page-shell-vue3";
import { MdsTabs, MdsTabsItem } from "@mds/tabs-vue3";
import { MdsButton } from "@mds/button-vue3";
import MdsEmptyState from '@mds/empty-state-vue3'
import router from "./router";
import {mapActions,mapGetters, mapState } from 'vuex';
import { AUTO_LOGIN_ACTION, IS_AUTH_USER, LOGOUT_ACTION } from './store/storeconstants';
import morningstarLogo from '@/assets/morningstarlogo.svg';

export default {
  name: "app",
  components: {
    MdsPageShell,
    MdsTabs,
    MdsTabsItem,
    MdsButton,
    MdsEmptyState
  },
  data() {
    return {
      logoUrl: morningstarLogo
    };
  },
  created(){
   this.$store.dispatch(`auth/${AUTO_LOGIN_ACTION}`);
  },
  computed: {
    ...mapState('auth',{
    userDetails:state=>state.userDetails,
    autoLogout:state=>state.autoLogout,
   }),
   ...mapGetters('auth',{
    isAuth:IS_AUTH_USER,
   }),
    isconferenceDetails: function () {
      try {
        if (this.$route.name == undefined) {
          return true;
        }
        return "conferenceDetails" === this.$route.name;
      } catch {        
        return true;
      }
    },
    iskeywordManagement: function () {
    try {
      if (this.$route.name == undefined) {
        return false;
      }
      return "keywordManagement" === this.$route.name;
    } catch {        
      return false;
    }
  },
    isuserList: function () {
      try {
        if (this.$route.name == undefined) {
          return true;
        }
        return "userList" === this.$route.name;
      } catch {        
        return true;
      }
    },
  },
  watch:{
    autoLogout(curValue,oldValue){
      if(curValue && curValue!=oldValue)
      {
        this.$router.replace('/login');
      }
    }
  },
  methods: {
    ...mapActions('auth',{
       logout:LOGOUT_ACTION,
    }),
    SignOut() {
      this.logout();
      this.$router.replace({ name: "Login" });
    },
  },
};
</script>

<style lang="scss">
@import "@mds/constants-vue3";
@import "@mds/typography-vue3";
@import "@mds/link-vue3";

body {
  @include mds-body-text-l();
  font-family: $mds-text-color-primary;
}

#dashboad,
#mds-page-shell-content {
  padding: $mds-space-3-x;
}

a {
  @include mds-link($underline: false);
}

h1 {
  @include mds-level-1-heading();
  text-align: left;
}

p {
  text-align: left;
}

.my-link {
  @include mds-link($underline: true);
}


</style>
